const ENV = process.env.REACT_APP_ENV || process.env.NODE_ENV || 'development'
// const ENV = 'production';
const CONFIG = {
  production: {
    API_ENDPOINT: 'https://api.getmalus.com/api',
  },
  development: {
    API_ENDPOINT: 'http://localhost:5000/api',
    // API_ENDPOINT: 'https://api.getmalus.com/api',
    // API_ENDPOINT: 'http://localhost:3000/api',
  },
  test: {
    API_ENDPOINT: 'http://192.168.111.244:5000/api',
  },
  staging: {
    API_ENDPOINT: 'https://stg-402.getmalus.com/api',
  },
}

module.exports = {
  ENV,
  API_ENDPOINT: CONFIG[ENV].API_ENDPOINT,
}
